export default {
    heading: "Welcome to your new career!",
    desc: "Earn while you learn. Avoid heavy student debt. Pave a pathway to a promising career and a brighter future. It’s all possible through apprenticeship.",
    videoURL: "https://www.youtube.com/embed/Dafll8lkRvU"
}